var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCommon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 24,
    viewBox: "0 0 222 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.232 8.81504C221.644 8.44826 221.682 7.81621 221.315 7.40332L215.336 0.674908C214.969 0.262019 214.337 0.224643 213.924 0.591425C213.511 0.958207 213.474 1.59026 213.841 2.00315L219.156 7.98396L213.176 13.2969C212.763 13.6637 212.726 14.2957 213.093 14.7086C213.46 15.1215 214.092 15.1589 214.505 14.7921L221.232 8.81504ZM0.839512 24.0066C83.1704 5.46281 131.671 3.81251 220.509 9.06568L220.626 7.0692C131.657 1.80827 82.9608 3.45984 0.399507 22.0556L0.839512 24.0066Z",
    fill: "#006D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCommon);
export default __webpack_public_path__ + "static/media/ArrowCommon.4301b4cfbfa790e36db47f2a15f68b26.svg";
export { ForwardRef as ReactComponent };